"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
require("rxjs");
const i0 = require("@angular/core");
class UpdateDAPAndDACTechOneFacilityService {
    constructor(dataService) {
        this.dataService = dataService;
    }
    updateDapAndDac(facilityId) {
        return this.dataService.put("updateDAPAndDACTechOneFacility?facilityId=" + facilityId, {});
    }
}
exports.UpdateDAPAndDACTechOneFacilityService = UpdateDAPAndDACTechOneFacilityService;
UpdateDAPAndDACTechOneFacilityService.ɵfac = function UpdateDAPAndDACTechOneFacilityService_Factory(t) { return new (t || UpdateDAPAndDACTechOneFacilityService)(i0.ɵɵinject('dataService')); };
UpdateDAPAndDACTechOneFacilityService.ɵprov = i0.ɵɵdefineInjectable({ token: UpdateDAPAndDACTechOneFacilityService, factory: UpdateDAPAndDACTechOneFacilityService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UpdateDAPAndDACTechOneFacilityService, [{
        type: core_1.Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['dataService']
            }] }]; }, null); })();
